import { render, staticRenderFns } from "./Medical.vue?vue&type=template&id=ccff05a2&scoped=true"
import script from "./Medical.vue?vue&type=script&lang=js"
export * from "./Medical.vue?vue&type=script&lang=js"
import style0 from "./Medical.vue?vue&type=style&index=0&id=ccff05a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccff05a2",
  null
  
)

export default component.exports